














































































import { defineComponent, PropType, ref } from '@vue/composition-api';
import sl from '@/serviceLocator';
import { FieldInfo } from '@oare/types';
import AddDescription from '@/components/Description/components/AddDescription.vue';
import EditDescription from '@/components/Description/components/EditDescription.vue';

export default defineComponent({
  props: {
    descriptions: {
      type: Array as PropType<FieldInfo[]>,
      required: true,
    },
    referenceUuid: {
      type: String,
      required: true,
    },
    allowCUD: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AddDescription,
    EditDescription,
  },
  setup({ referenceUuid }, { emit }) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const isAdding = ref(false);
    const isEditing = ref(false);
    const isDeleting = ref(false);
    const updateOrDeleteDescription = ref('');
    const updateOrDeleteUuid = ref('');
    const updateOrDeletePrimacy = ref(-1);
    const editingIndex = ref(-1);

    const openEdit = (
      uuid: string,
      description: string,
      primacy: number,
      index: number
    ) => {
      isEditing.value = true;
      updateOrDeleteDescription.value = description;
      updateOrDeleteUuid.value = uuid;
      updateOrDeletePrimacy.value = primacy;
      editingIndex.value = index;
    };

    const openDelete = (uuid: string, description: string, primacy: number) => {
      isDeleting.value = true;
      updateOrDeleteDescription.value = description;
      updateOrDeleteUuid.value = uuid;
      updateOrDeletePrimacy.value = primacy;
    };

    const deleteDescription = async () => {
      try {
        await server.deletePropertyDescriptionField({
          uuid: updateOrDeleteUuid.value,
          referenceUuid: referenceUuid,
          primacy: updateOrDeletePrimacy.value,
          type: 'description',
        });
      } catch (err) {
        actions.showErrorSnackbar(
          'unable to delete selected description',
          err as Error
        );
      } finally {
        refreshPage();
      }
    };

    const refreshPage = () => {
      updateOrDeleteUuid.value = '';
      updateOrDeleteDescription.value = '';
      updateOrDeletePrimacy.value = -1;
      editingIndex.value = -1;
      isDeleting.value = false;
      isEditing.value = false;
      isAdding.value = false;
      emit('refresh-page');
    };

    return {
      openEdit,
      openDelete,
      deleteDescription,
      refreshPage,
      isAdding,
      isEditing,
      isDeleting,
      updateOrDeleteDescription,
      updateOrDeletePrimacy,
      updateOrDeleteUuid,
      editingIndex,
    };
  },
});
